import { render, staticRenderFns } from "./TariffCalculatorHeatingTypeSelect.vue?vue&type=template&id=5fdafba0&"
import script from "./TariffCalculatorHeatingTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorHeatingTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports